import Clinica1 from '../../assets/clinica1.jpg';
import Clinica2 from '../../assets/clinica2.jpg';
import Clinica3 from '../../assets/clinica3.jpg';
import Clinica4 from '../../assets/clinica4.jpg';

const clinicas = [
  Clinica2,
  Clinica1,
  Clinica3,
  Clinica4,
];

export default clinicas;
